import { ListingsSearchBarConnected } from '@components/listings-search-bar';
import React, { type FC } from 'react';
import { SearchBarTooltip } from './SearchBarTooltip';
import { SemanticControls } from './SemanticControls';
import Styles from './SemanticSearch.styles.scss';

export interface SemanticSearchProps {
	/**
	 * Hide this input (and its tooltip) while the condensed copy is showing in
	 * the sticky filter row.
	 * `ListingsSearchBarConnected` has a static input `id`, so only one instance
	 * can be mounted at a time. A placeholder keeps its footprint so the header
	 * row doesn't collapse and shift the page.
	 */
	hideSearchBar?: boolean;
}

export const SemanticSearch: FC<SemanticSearchProps> = ({
	hideSearchBar = false,
}) => {
	return (
		<div className={Styles.semanticSearchWrapper}>
			<SemanticControls />
			{hideSearchBar ? (
				<div
					aria-hidden="true"
					className={Styles.searchBarPlaceholder}
					data-testid="search-bar-placeholder"
				/>
			) : (
				<>
					<ListingsSearchBarConnected />
					<SearchBarTooltip />
				</>
			)}
		</div>
	);
};
